// extracted by mini-css-extract-plugin
module.exports = {"container":"CTA_container__1JkYh","border":"CTA_border__wReSs","rectangle":"CTA_rectangle__1lZa1","text":"CTA_text__2jMEb","gradient":"CTA_gradient__tBRCh"};